import { v5 as uuidv5 } from 'uuid';
import type { OutboxItem } from './types';

/** uuidv5(`${step}:${index ?? ''}:#${item.uploadGen ?? 0}`, item.id): stable across retries and app restarts, distinct per
 *  request, and fresh for each upload generation (a restarted upload never reuses a key whose body has changed). */
export function keyFor(item: OutboxItem, step: string, index?: number): string {
  return uuidv5(`${step}:${index ?? ''}:#${item.uploadGen ?? 0}`, item.id);
}
